import { useMutation } from "@tanstack/react-query";
import { use } from "react";
import { useAuthentication } from "../auth/useAuthentication.ts";
import { useTranslator } from "../i18n/translator.ts";
import { SnackbarContext } from "../snackbar/SnackbarContext.ts";

export const useExportCards = () => {
  const { getToken } = useAuthentication();
  const translator = useTranslator();
  const { displayError } = use(SnackbarContext);

  return useMutation({
    mutationFn: async (): Promise<Blob> => {
      const token = await getToken();
      const response = await fetch("/api/cards/export", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Server returned status outside the 200 range.");
      }
      return response.blob();
    },
    onSuccess: (blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "cards-export.csv";
      document.body.appendChild(link);
      try {
        link.click();
      } finally {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    },
    onError: () => {
      displayError(translator("errorExportCards"));
    },
  });
};
